export default __webpack_public_path__ + "static/media/img2.939cbb7e.png";